<template>
  <div
    class="folders file-wrapper"
    :class="{
      selecteditems:
        showFooter ||
        $store.state.SelectedImagesList.length ||
        $store.state.MoveFolderSlectedId,
    }"
  >
    <div
      @click="showmodel = isSelectedIndex = false"
      :class="showmodel ? 'close-option show_overlay' : 'close-option'"
    ></div>

    <h2 v-if="!$route.params.name">{{$t('Folders')}} ({{ FolderListData.length }})</h2>
     <div
        class="no-data"
        v-if="!(getUserFileData.length) && !(getUserFolderData.length)"
      >
        <img :src="require('../assets/images/ic_blank_data.svg')" alt />
        <span>{{$t('No Data Found')}}</span>
      </div>
    <ul class="folder-listing">
      <li
        class="list"
        v-if="FolderListData.length"
        v-for="(getUserFile, index) in FolderListData"
        :key="index"
      >
        <div
          class="inner"
          @click.stop="redirect(getUserFile.folder_id, getUserFile.folder_name)"
        >
          <span class="icon">
            <img src="../assets/images/ic_folder.svg" alt />
          </span>
          <div class="text">
            <h3>{{ getUserFile.folder_name }}</h3>
            <span
              >{{ getUserFile.file_count }}{{$t('Files')}} | {{ new Date(getUserFile.date).toLocaleDateString() }}</span
            >
          </div>
        </div>
        <div class="dot-icon">
          <span class="option-icon" @click="active(index)">
            <img src="../assets/images/ic_dots.svg" alt />
          </span>
          <ul
            :class="
              isSelectedIndex === index
                ? 'option-list show-option'
                : 'option-list'
            "
          >
            <li class="rename-file" @click="renamefolder(index)">
              <span class="opt-icon">
                <img src="../assets/images/ic_folder.svg" alt />
              </span>
              {{$t('Rename Folder')}}
            </li>
            <li
              class="move-file"
              @click="moveFolderFrom(index, getUserFile.folder_id)"
            >
              <span class="opt-icon">
                <img src="../assets/images/ic_move.svg" alt />
              </span>
              {{$t('Move Folder')}}
            </li>
            <li class="delete-file" @click="deleteFolder(index)">
              <span class="opt-icon">
                <img src="../assets/images/ic_trash.svg" alt />
              </span>
              {{$t('Delete Folder')}}
            </li>
          </ul>
        </div>
      </li>
      <li class="file-block">
        <div
          class="file-item"
          :id="`move${index}`"
          v-if="FileListData.length"
          v-for="(item, index) in FileListData"
          :key="index"
          @click="selectFiles(index, item)"
        >
          <component
            v-if="item && item.data_url"
            :url="item.data_url"
            :is="findMimeTypeViewer(item, index)"
          ></component>
          <span class="select-icon"></span>
          <div class="file-title">
            <span>{{ item.data_name }}</span>
          </div>
        </div>
      </li>
      <loader91 v-if="isLoading"></loader91>
      <span class="load-more" @click="loadMore" v-if="((getUserFile.total_data >= 5 || getUserFile.total_folder >= 5) && !$store.state.SearchValue)"> {{noMoreData}} </span>
    </ul>
    <!-- add popup -->
    <div class="add-popup" :class="{ active: showAddPopup }">
      <ul>
        <li class="create-folder">
          <img src="../assets/images/ic_folder.svg" alt />
          <span @click="showCreate">{{$t('Create Folder')}}</span>
        </li>
        <li>
          <img src="../assets/images/ic_upload.svg" alt="" />

          <span class="upload-file">
            {{$t('Upload')}}
            <input
              type="file"
              id="myFile"
              multiple="multiple"
              @change="uploadFile"
              ref="myfile"
              name="upload"
            />
          </span>
        </li>
      </ul>
    </div>
    <span class="add-btn" @click="addbtn">
      <img
        src="../assets/images/ic_add.svg"
        :class="{ rotate: showRotate }"
        alt
      />
    </span>

    <div class="create-popup" :class="{ active: showModelCreate }">
      <div class="content animated fadeInUp faster">
        <h2>{{$t('Create Folder')}}</h2>
        <label for>{{$t('Folder Name')}}</label>
        <input
          type="text"
          v-model="fileName"
          :placeholder="$t('Folder Name')"
        />
        <span @click="createFolder()" class="save-btn">{{$t('Save')}}</span>
        <span class="close" @click="close">
          <img src="../assets/images/cross_red.svg" alt />
        </span>
      </div>
    </div>

    <!-- Uploading Popup -->
    <div class="uploading-popup" :class="{ active: showModelUpload }">
      <div
        class="up-content animated fadeInUp faster"
        :class="{ hid: showHid }"
      >
        <h2>{{$t('Uploading')}}</h2>
        <p>{{$t('Your file is getting upload')}}</p>
        <!-- <progress :value="uploadPercentage" max="100"> </progress> % {{uploadPercentage}} -->
        <div class="upload-bar">
          <div class="file-details">
            <span class="file-name">{{ image.name }}</span>
            <span :value="uploadPercentage" max="100" class="prcnt">
              {{ uploadPercentage }}
            </span>
          </div>
          <div class="line-bar">
            <!-- <progress class="grow" :value="uploadPercentage" max="100"> </progress> -->
            <span
              class="grow"
              :style="{ width: uploadPercentage + '%' }"
              :value="uploadPercentage"
              max="100"
            ></span>
          </div>
        </div>
        <span class="cancel-btn" @click="showUpload">{{$t('Cancel')}}</span>
      </div>
      <!-- Cancel Uploading -->
      <div
        class="cancel-uploading animated fadeInUp faster"
        :class="{ show: showShow }"
      >
        <h2>{{$t('Cancel Uploading')}}</h2>
        <p>{{$t('Are you sure want to cancel ?')}}</p>
        <div class="btn">
          <span class="c-yes" @click="CancelUpload">{{$t('Yes')}}</span>
          <span class="c-no" @click="notCancelUpload">{{$t('No')}}</span>
        </div>
      </div>
    </div>


    <!-- Delete Popup -->
    <div class="delete-popup" :class="{ active: showDelete }">
      <div class="delete-content animated fadeInUp faster">
        <h2>{{$t('Delete')}}</h2>
        <p>{{$t('Are you sure want to delete ?')}}</p>
        <div class="btn">
          <span class="yes-delete" @click="CorfrimedDelete(true)">{{$t('Yes')}}</span>
          <span class="no-delete" @click="close()">{{$t('No')}}</span>
        </div>
      </div>
    </div>
    
    <div class="delete-popup" :class="{ active: showFileDelete }">
      <div class="delete-content animated fadeInUp faster">
        <h2>{{$t('Delete')}}</h2>
        <p>{{$t('Are you sure want to delete ?')}}</p>
        <div class="btn">
          <span class="yes-delete" @click="deleteFile()">{{$t('Yes')}}</span>
          <span class="no-delete" @click="close()">{{$t('No')}}</span>
        </div>
      </div>
    </div>

    <div class="create-popup renameFolder" :class="{ active: showmodelActive }">
      <div class="content animated fadeInUp faster">
        <h2>{{$t('Rename Folder/File')}}</h2>
        <label for>{{$t('Folder Name / File Name')}}</label>
        <input type="text" v-model="rename" :placeholder="renameFolderName" />
        <span @click="renamFolder()" class="save-btn">{{$t('Save')}}</span>
        <span class="close" @click="close()">
          <img src="../assets/images/cross_red.svg" alt />
        </span>
      </div>
    </div>

    <div
      class="move-ftr"
      v-if="
        ($store.state.SelectedImagesList.length ||
          $store.state.MoveFolderSlectedId) &&
          $store.state.CurrentFolderId !== $store.state.routeFolderId
      "
    >
      <span class="cancel-btn" @click="removeFooter">{{$t('Cancel')}}</span>
      <span
        class="move-btn"
        @click="moveFile"
        v-if="$store.state.SelectedImagesList.length"
      >
        {{$t('Move File')}}
      </span>
      <span
        class="move-btn"
        @click="moveFolder"
        v-if="$store.state.MoveFolderSlectedId"
      >
        {{$t('Move Folder')}}
      </span>
    </div>

    <footer class="option-footer" :class="{ active: showFooter }">
      <div class=" item" @click="moveShowFile()">
        <img src="../assets/images/ic_moveBlue.svg" alt />
        <span>{{$t('Move')}}</span>
      </div>
      <div class="item2" @click="handlefileShare()">
        <img src="../assets/images/ic_share.svg" alt />
        <span>{{$t('Share')}}</span>
      </div>
      <div class="item3" @click="renamefile">
        <img src="../assets/images/ic_rename.svg" alt />
        <span>{{$t('Rename')}}</span>
      </div>
      <div class="item4" @click="deletefile()">
        <img src="../assets/images/ic_delete.svg" alt />
        <span>{{$t('Delete')}}</span>
      </div>
      <div class="item5" @click="downloadFile()">
        <a  id="downloadFile">
          <img src="../assets/images/ic_download.svg" alt
        /></a>
        <span>{{$t('Download')}}</span>
      </div>
    </footer>
  </div>
</template>
<script>
import ImageViewer from "./FileViewer/ImageViewer";
import DefaultViewer from "./FileViewer/DefaultViewer";
import DocsViewer from "./FileViewer/DocsViewer";
import VideoViewer from "./FileViewer/VideoViewer";
import Mp3SoundViewer from "./FileViewer/Mp3SoundViewer";
import ZipViewer from "./FileViewer/ZipViewer";
import { SessionHelper, LANG } from "../utils/session";
import constant from "../utils/constant";
// import { getBase64Url } from "../utils/helper";
import axios from "axios";
import axiosCancel from "axios-cancel";
// import AES from "crypto-js/aes"
import { mapGetters } from "vuex";
// import Crypto from 'crypto-js';
// import VueJwtDecode from 'vue-jwt-decode'
// import VueCryptojs from '../main'
export default {
  name: "folder",
  data() {
    return {
      del: name,
      Limit:0,
      activeFolderindex: "",
      selectedImagesList: [],
      activeMoveIcon: false,
      activeFolderFrom: "",
      activeFolderTo: "",
      showMoveFile: false,
      showMoveFileBtn: false,
      showDelete: false,
      showFileDelete: false,
      showMove: false,
      uploadPercentage: 0,
      array: [],
      isLoading: true,
      showModelCreate: false,
      showShow: false,
      showHid: false,
      image: "",
      fileName: "",
      showModelUpload: false,
      showmodel: false,
      showFooter: false,
      showmodelActive: false,
      rename: "",
      showAddPopup: false,
      showRotate: false,
      folderRename: "",
      folder_name: "",
      downloadUrl: "",
      selectedFiles: [],
      selectedDownload: [],
      selectingFolder: [],
      selectedFolder: "",
      isSelectedIndex: "",
      activeFolderRenameindex: "",
      currentFolderId: null,
      selectedFolderId: null,
      renameFolderName: null,
      FolderListData: [],
      FileListData: [],
      noMoreData: 'Load More',
      source: null
    };
  },

  components: {
    ImageViewer,
    DefaultViewer,
    DocsViewer,
    VideoViewer,
    Mp3SoundViewer,
    ZipViewer,
  },
  computed: {
    ...mapGetters([
      "getUserFile",
      "getFolderId",
      "getUserFileData",
      "getUserFolderData",
      "getUserInfo"
    ]),
  },
  async mounted() {
    this.userFile();
    let addPopup = document.querySelector(".add-popup");
    let addimg = document.querySelector(".add-btn img");
  },
  watch: {
    selectedImagesList: function(newVal, oldVal) {
      if (!newVal.length) {
        this.showMoveFileBtn = false;
      }
    },
    getUserFolderData: function(newVal, oldVal){
      this.FolderListData = newVal
      
    },
    getUserFileData: function(newVal, oldVal){
      this.FileListData = newVal
    },
    FolderListData: function(newVal, oldVal){
      this.$store.commit('FolderListDataLength',newVal.length)
    },
    FileListData: function(newVal, oldVal){
      this.$store.commit('FileListDataLength',newVal.length)
    }
  },

  methods: {
    removeFooter() {
      this.$store.commit("setSelectedImagesList", []);
      this.$store.commit("setMoveFolderSlectedId", "");
    },
    handlefileShare() {
      if (this.selectedImagesList.length === 1) {
      this.$store.dispatch({type: 'getUserDataPayboard'}).then(({data})=>{
         var deepLinkUrl = `https://m91.co/${data.userSetting.userDeepLink}`
         console.log(deepLinkUrl)
         try {  
          JSBridgePlugin.downloadVideoAndShare(this.downloadUrl,
          `Mall91 - 1 करोड़+ भारतवासियों की विश्वसनीय सुपर ऐप! घर बैठे बैठे ढेरों कमाएं और अपने कमाई का उपयोग करें दैनिक ज़रूरतों का सामान खरीदने में, रीचार्ज/बिल्स भुगतान में या किसी भी दूकान पर पेमेंट करने में!\n\nकमाना है बड़ा आसान - बस अपने दोस्तों को रेफेर करके नेटवर्क बनाकर, या मज़ेदार गेम्स टूर्नामेंट्स खेल कर, या सिर्फ हमारे प्रोडक्ट्स व्हाट्सऐप पर शेयर करके! नेटवर्क की हर खरीद पर आप पाएंगे अलग से कमीशन! यही नहीं, हमारी कई और मिनी-ऐप्स उपयोग करें और बनाएं अपने दैनिक जीवन को और भी आसान\n\nयहाँ से डाउनलोड करें और मेरे रेफरल कोड ${data.referralCode} का उपयोग करें ${deepLinkUrl}`
          );
        } catch (e) {
          console.log(e);
        }
      })
      .catch((err)=>{
        console.log('==0err',err.response)
      })
     
      } else {
        this.$toast.bottom(this.$t('You can share one file at a time'));
      }
    },
    findMimeTypeViewer(item, index) {
      let activeUrl = index;
      let url = item.data_url;
      let urlArray = url && url.split(".");
      let mimeType = urlArray[urlArray.length - 1];
      const imagesMimeTypes = ["jpg", "jpeg", "png"];
      const videosMimeTypes = ["mp4", "WebM", "Ogg"];
      const docsMimeTypes = ["pptx", "doc", "docx", "pdf", "xlsx"];
      if (imagesMimeTypes.indexOf(mimeType) > -1) {
        return "ImageViewer";
      } else if (videosMimeTypes.indexOf(mimeType) > -1) {
        return "VideoViewer";
      } else if (docsMimeTypes.indexOf(mimeType) > -1) {
        return "DocsViewer";
      } else if (item.data_type === ".mp3") {
        return "Mp3SoundViewer";
      } else if (item.data_type === ".zip") {
        return "ZipViewer";
      }
      return "DefaultViewer";
    },
    addbtn() {
      this.showAddPopup = !this.showAddPopup;
      this.showRotate = !this.showRotate;
    },
    deletefile() {
      this.showFileDelete = true;
    },
    moveShowFile() {
      if (this.selectedImagesList.length) {
        this.$store.commit("setSelectedImagesList", this.selectedImagesList);
        this.$toast.bottom(this.$t('Choose your folder and click on move here'));
        this.showMoveFileBtn = true;
        this.showMoveFile = true;
        this.showFooter = false;
      } else {
        this.showMoveFile = false;
        this.showMoveFileBtn = false;
      }
    },
    // Downloadfile(){

    // },
    notCancelUpload() {
      this.showHid = false;
      this.showShow = false;
    },
    showUpload() {
      this.showHid = true;
      this.showShow = true;
    },
    showCreate() {
      this.showModelCreate = true;
      this.showAddPopup = false;
      this.showRotate = false;
      this.showMove = false;
      this.showMoveFile = false;
    },
    CancelUpload() {
      this.showModelUpload = false;
      this.showHid = false;
      this.showShow = false;
      this.source.cancel('Operation canceled by the user.');    
    },
    close() {
      this.showmodelActive = false;
      // this.showmodel = false;
      this.showDelete = false;
      this.showFileDelete = false;
      this.showMove = false;
      this.showModelCreate = false;
      this.showModelUpload = false;
      this.showHid = false;
      this.showShow = false;
      this.showMoveFile = false;
    },
    active(index) {
      this.isSelectedIndex = index;
      this.showmodel = true;
    },
    loadMore(){
      if(this.noMoreData === this.$t('Load More')){
        this.Limit = this.Limit + 5
        let file_id = "";
        this.isLoading = true
        if (this.$route.params.name !== undefined) {
          let file_id_string = this.$route.params.name.split("/");
          file_id = file_id_string[file_id_string.length - 1];
        }
         this.$store
          .dispatch("userFile", {
            headers: {
              "folder-id": file_id,
              Limit: this.Limit,
            },
          })
          .then((response) => {
            this.isLoading = false
             this.FolderListData = [...this.FolderListData,  ...response.folder]
             this.FileListData = [...this.FileListData , ...response.Data]
             if(!response.Data.length && !response.folder.length){
               this.noMoreData = this.$t('No more Data')
             }
          })
          .catch((err) => {
          this.isLoading = false
          if((err.response.data.message === 'Token is expired!') || (err.response.data.message === 'Invalid token.')){
          SessionHelper.refereshJwtToken();
          if (SessionHelper.getCookie('JWT-TOKEN') !== 'null') {
            this.loadMore()
          }
        }
        });
      }
    },

    async userFile() {
      this.Limit = 0
      let file_id = "";
      if (this.$route.params.name !== undefined) {
        let file_id_string = this.$route.params.name.split("/");
        file_id = file_id_string[file_id_string.length - 1];
      }
      await this.$store
        .dispatch("userFile", {
          headers: {
            "folder-id": file_id,
            Limit: 0,
          },
        })
        .then((response) => {
          this.$store.dispatch({
            type: 'getUserProfile'
          });
          this.$store.commit('setUserFile', response);
          this.$store.commit('setUserFolderData', response.folder);
          this.$store.commit('setUserFileData', response.Data);
          this.FolderListData = response.folder
          this.FileListData = response.Data
          this.noMoreData = this.$t('Load More')
          if (this.$route.params.name !== undefined) {
            // this.currentFolderId = file_id
            this.$store.commit("setCurrentFolderId", file_id);
          } else {
            this.$store.commit("setCurrentFolderId", this.getUserFile.root);
          }
          console.log(
            "=selectedFolderId=mounted=",
            this.$store.state.RouteFolderId,
            this.currentFolderId
          );
          this.selectedImagesList = [];
          var els = document.querySelectorAll('.select-img');
          for (var i = 0; i < els.length; i++) {
            els[i].classList.remove('select-img');
          }
          this.isLoading = false;
        }).catch((err)=>{
        if((err.response.data.message === 'Token is expired!') || (err.response.data.message === 'Invalid token.')){
          SessionHelper.refereshJwtToken();
          if (SessionHelper.getCookie('JWT-TOKEN') !== 'null') {
            this.userFile()
          }
        }
      })
    },
    async uploadFile(file) {
      let totalFileSize = 0
      console.log('=file.target.files[0];==', file.target.files[0], this.$refs.myfile.files)
      if(this.getUserInfo.total_file_size){
       totalFileSize = this.getUserInfo.total_file_size.split(' ')[0]*1000000
      }
      let remainingMemory = this.getUserInfo.total_storage - totalFileSize
      console.log('==remainingMemory=',remainingMemory)
      if(this.getUserInfo.percentage === 100){
        this.showAddPopup = false;
        return this.$toast.bottom(this.$t('Insufficient Memory'));
      }
      if(file.target.files[0].size > remainingMemory){
        this.showAddPopup = false;
        return this.$toast.bottom(this.$t('Insufficient Memory'));
      }
      const CancelToken = axios.CancelToken;
        // create the source
      this.source = CancelToken.source();
      var _this = this;
      let file_id = "";
      if (_this.$route.params.name !== undefined) {
        let file_id_string = _this.$route.params.name.split("/");
        file_id = file_id_string[file_id_string.length - 1];
      }
      _this.showModelUpload = true;
      _this.showAddPopup = false;
      _this.showRotate = false;
      _this.image = file.target.files[0];
      console.log('= _this.image==', _this.image)
      const formData = new FormData();
      formData.append("myFile", _this.image);
      formData.append("folderId", file_id || this.getUserFile.root);
      // this.getUserFile.root
      // "Authorization": `Bearer ${SessionHelper.getCookie('JWT-TOKEN')}`,
      await axios
        .post(constant.FILE_UPLOAD_URL, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-Auth-Id": SessionHelper.getCookie("X-Auth-Id"),
            "JWT-TOKEN": SessionHelper.getCookie("JWT-TOKEN"),
            "Authorization": `Bearer ${SessionHelper.getCookie('JWT-TOKEN')}`
          },
          cancelToken: this.source.token,
          onUploadProgress: function(uploadEvent) {
             document.getElementById('myFile').value = ''
            _this.uploadPercentage = Math.round(
              (uploadEvent.loaded / uploadEvent.total) * 100
            );
          },
        })
        .then((data) => {
          console.log('===data===',data.data.Success)
           if(!data.data.Success){
             _this.showModelUpload = false;
            _this.showHid = false;
            _this.showShow = false;
            _this.isLoading = true;
             return _this.$toast.bottom(data.data.Message);
           }
          _this.showModelUpload = false;
          _this.showHid = false;
          _this.showShow = false;
          _this.isLoading = true;
          _this.userFile();
        })
        .catch((err) => {
          if((err.response.data.message === 'Token is expired!') || (err.response.data.message === 'Invalid token.')){
           SessionHelper.refereshJwtToken();
          if (SessionHelper.getCookie('JWT-TOKEN') !== 'null') {
            this.uploadFile()
          }
        }
        });

      // else {
      //   alert("File size must be smaller than 50MB")
      // }
    },
    createFolder() {
      // this.folderPath = this.$route.params.name;
      if(this.getUserInfo.percentage === 100){
        this.showAddPopup = false;
        return this.$toast.bottom(this.$t('Insufficient Memory'));
      }
      let file_id = this.getUserFile.root;
      if (this.$route.params.name !== undefined) {
        let file_id_string = this.$route.params.name.split("/");
        file_id = file_id_string[file_id_string.length - 1];
      }
      this.$store
        .dispatch({
          type: "createFolder",
          payload: {
            folder_name: this.fileName,
            folder_id: file_id,
          },
        })
        .then((data) => {
          // this.folder
          // this.folder_path=data
          if(!data.status){
              this.fileName = null
              this.showModelCreate = false;
              this.isLoading = false;
             return this.$toast.bottom(data.message);
           }
          this.$toast.bottom(data.message);
          this.fileName = null
          this.userFile();
          this.showModelCreate = false;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          if((err.response.data.message === 'Token is expired!') || (err.response.data.message === 'Invalid token.')){
          SessionHelper.refereshJwtToken();
          if (SessionHelper.getCookie('JWT-TOKEN') !== 'null') {
            this.createFolder()
          }
        }
        });
    },
    // forceFileDownload(){
    //   const url = window.URL.createObjectURL(new Blob([this.downloadUrl]))
    //   const link = document.createElement('a')
    //   link.href = this.downloadUrl
    //   link.setAttribute('download', 'file.jpg') //or any other extension
    //   document.body.appendChild(link)
    //   link.click()
    // },
    downloadFile() {
      this.selectedFiles = [];
      this.showFooter = false;
      if(this.selectedImagesList.length === 1 && this.downloadUrl){
        var ele = document.getElementById('downloadFile')
        ele.setAttribute('href', this.downloadUrl);
      }else{
        var ele = document.getElementById('downloadFile')
        ele.setAttribute('href', '#');
        this.$toast.bottom(this.$t('You can download one file at time'));
      }
      //  const arr = this.array.join()
    },
    renamefolder(index) {
      this.activeFolderindex = index;
      this.rename = this.getUserFile.folder[this.activeFolderindex].folder_name;
      this.folderRename = null;
      this.showmodelActive = true;
    },
    renamefile() {
      if (this.selectedImagesList.length === 1) {
        this.showmodelActive = true;
        this.folderRename = 2;
        this.getUserFile.Data.filter((item) => {
          if (item.data_id === this.selectedImagesList[0]) {
            this.rename = item.data_name;
          }
        });
        // this.getUserFile.folder[this.activeFolderindex].folder_id = null;
      } else {
        this.$toast.bottom("you can rename one file at a time");
      }
    },
    renamFolder() {
      // this part for Folder rename in if
      if (this.folderRename === null) {
        this.$store
          .dispatch({
            type: "renameFolder",
            payload: {
              file_id: null,
              folder_name: this.rename,
              folder_id: this.getUserFile.folder[this.activeFolderindex]
                .folder_id,
            },
          })
          .then((data) => {
            this.$toast.bottom(this.$t('Rename successfull'));
            this.userFile();
            this.showmodelActive = false;
            this.showFooter = false;
            this.isLoading = true;
            this.getUserFile.folder[this.activeFolderindex].folder_id = null;
            this.showmodel = this.isSelectedIndex = false;
          })
          .catch((err) => {
          if((err.response.data.message === 'Token is expired!') || (err.response.data.message === 'Invalid token.')){
          SessionHelper.refereshJwtToken();
          if (SessionHelper.getCookie('JWT-TOKEN') !== 'null') {
            this.renamFolder()
          }
        }
        });
      }
      // this part for File Rename in esle
      else {
        this.$store
          .dispatch({
            type: "renameFolder",
            payload: {
              file_id: this.selectedImagesList[0],
              folder_name: this.rename,
              folder_id: null,
            },
          })
          .then((data) => {
            this.$toast.bottom(this.$t('Rename successfull'));
            this.userFile();
            this.showmodelActive = false;
            this.showFooter = false;
            this.selectedFiles = [];
            this.selectedImagesList = [];
            this.isLoading = true;
          })
          .catch((err) => {
          if((err.response.data.message === 'Token is expired!') || (err.response.data.message === 'Invalid token.')){
          SessionHelper.refereshJwtToken();
          if (SessionHelper.getCookie('JWT-TOKEN') !== 'null') {
            this.renamFolder()
          }
        }
        });
      }
    },
    moveFolderFrom(index, fid) {
      this.activeFolderFrom = index;
      this.showMove = false;
      this.isSelectedIndex = false;
      this.$store.commit("setRouteFolderId", this.$store.state.CurrentFolderId);
      this.$store.commit("setMoveFolderSlectedId", fid);
    },
    // moveFolderTo(index) {
    //   this.$set(this.selectingFolder, index, !this.selectingFolder[index]);
    //   this.activeFolderTo = index;
    // },
    moveFolder() {
      let fromPath = this.$store.state.MoveFolderSlectedId;
      let toPath = this.$store.state.CurrentFolderId;
      this.$store
        .dispatch({
          type: "moveFolder",
          payload: {
            from_folder_id: fromPath,
            to_folder_id: toPath,
          },
        })
        .then((data) => {
          this.userFile();
          this.showMove = false;
          this.isLoading = true;
          this.showmodel = this.isSelectedIndex = false;
          this.$store.commit("setMoveFolderSlectedId", "");
        })
        .catch((err) => {
          if((err.response.data.message === 'Token is expired!') || (err.response.data.message === 'Invalid token.')){
          SessionHelper.refereshJwtToken();
          if (SessionHelper.getCookie('JWT-TOKEN') !== 'null') {
            this.moveFolder()
          }
        }
        });
    },
    moveFile() {
      let fromPath = this.$store.state.SelectedImagesList;
      let toPath = this.$store.state.CurrentFolderId;
      this.$store
        .dispatch({
          type: "moveFile",
          payload: {
            from_folder_id: fromPath,
            to_folder_id: toPath,
          },
        })
        .then((data) => {
          this.$store.commit("setRouteFolderId", "");
          this.$store.commit("setCurrentFolderId", "");
          this.$store.commit("setSelectedImagesList", []);
          this.$toast.bottom(data.Msg);
          this.userFile();
          this.showMoveFile = false;
          this.showFooter = false;
          this.selectedFiles = [];
          this.isLoading = true;
        })
        .catch((err) => {
          if((err.response.data.message === 'Token is expired!') || (err.response.data.message === 'Invalid token.')){
          SessionHelper.refereshJwtToken();
          if (SessionHelper.getCookie('JWT-TOKEN') !== 'null') {
            this.moveFolder()
          }
        }
        });
    },
    deleteFile() {
      const arr = this.selectedImagesList.join();
      this.$store
        .dispatch({
          type: "deleteFile",
          payload: {
            file_id: arr,
          },
        })
        .then((data) => {
          this.$toast.bottom(this.$t('file Deleted Successfully'));
          this.userFile();
          this.showFileDelete = false;
          this.showFooter = false;
          this.selectedFiles = [];
          this.isLoading = true;
        })
        .catch((err) => {
          if((err.response.data.message === 'Token is expired!') || (err.response.data.message === 'Invalid token.')){
          SessionHelper.refereshJwtToken();
          if (SessionHelper.getCookie('JWT-TOKEN') !== 'null') {
            this.deleteFile()
          }
        }
        });
    },
    CorfrimedDelete(value) {
      if (value) {
        const folderName = this.getUserFile.folder.map(
          (folder) => folder.folder_id
        );
        this.fileName = this.getUserFile.folder.folder_name;
        this.$store
          .dispatch({
            type: "deleteFolder",
            payload: {
              folder_id: this.getUserFile.folder[this.activeFolderindex]
                .folder_id,
              // folder_path: this.folderPath || ""
            },
          })
          .then((data) => {
            this.$toast.bottom(data.Delete);
            this.userFile();
            this.showDelete = false;
            this.showmodel = this.isSelectedIndex = false;
          })
          .catch((err) => {
          if((err.response.data.message === 'Token is expired!') || (err.response.data.message === 'Invalid token.')){
          SessionHelper.refereshJwtToken();
          if (SessionHelper.getCookie('JWT-TOKEN') !== 'null') {
            this.CorfrimedDelete()
          }
        }
        });
      }
    },
    deleteFolder(name) {
      this.activeFolderindex = name;
      this.showDelete = true;
    },

    selectFiles(index, item) {
      if (this.selectedImagesList.includes(item.data_id)) {
        // this.downloadUrl = null;
        document.getElementById(`move${index}`).classList.remove("select-img");
        this.selectedImagesList.splice(
          this.selectedImagesList.indexOf(item.data_id),
          1
        );
      } else {
        this.downloadUrl = item.data_url;
        document.getElementById(`move${index}`).classList.add("select-img");
        this.selectedImagesList.push(item.data_id);
        this.$store.commit(
          "setRouteFolderId",
          this.$store.state.CurrentFolderId
        );
      }
      if (this.selectedImagesList.length) {
        this.showFooter = true;
      } else {
        this.showFooter = false;
      }
    },

    redirect(value, name) {
      this.$store.commit("setSelectedFolder", {
        newName: value,
      });
      if (this.$route.params.name !== undefined) {
        this.$router.push({ path: `${this.$route.fullPath}/${value}` });
      } else {
        this.$router.push({ path: `/file/${value}` });
      }
    },
  },
};
</script>
